export default "__VITE_ASSET__ChMF9DLP__"